import {AdminService} from "@/services/admin-service.ts";
import {GradeService} from "@/services/grade-service.ts";
import {LessonService} from "@/services/lesson-service.ts";
import {EmailAuthService} from "@/services/email-auth.service.ts";
import {UserService} from "@/services/user-service.ts";
import {PaymentService} from "@/services/payments-service.ts";
import {GroupService} from "@/services/group-service.ts";
import {ExamService} from "@/services/exam-service.ts";

export class Api {
  auth = EmailAuthService.getInstance()
  admin = AdminService.getInstance();
  users = UserService.getInstance()
  grades = GradeService.getInstance();
  lessons = LessonService.getInstance();
  payments = PaymentService.getInstance();
  groups = GroupService.getInstance();
  exams = ExamService.getInstance();
}

export const api = new Api;